import { render, staticRenderFns } from "./VisitDeleteConfirm.vue?vue&type=template&id=579b6aee&scoped=true&"
import script from "./VisitDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./VisitDeleteConfirm.vue?vue&type=script&lang=ts&"
import style0 from "styles/pages/visit/other-dialog.less?vue&type=style&index=0&id=579b6aee&scoped=true&lang=less&"
import style1 from "styles/pages/health-file/dialogSection__el.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b6aee",
  null
  
)

export default component.exports